import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/Layout.vue'
import Login from '@/views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: Layout,
    redirect: '/vehicles',
    children: [
      {
        path: 'vehicles',
        name: 'Vehicles',
        component: () => import('@/views/Vehicles.vue'),
        meta: { title: '车辆管理' }
      },
      {
        path: 'reports',
        name: 'Reports',
        component: () => import('@/views/Reports.vue'),
        meta: { title: '检测报告管理' }
      },
      {
        path: 'images',
        name: 'Images',
        component: () => import('@/views/Images.vue'),
        meta: { title: '图片管理' }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/Settings.vue'),
        meta: { title: '温馨提示管理' }
      },
      {
        path: 'guarantee',
        name: 'GuaranteeManage',
        component: () => import('@/views/GuaranteeManage.vue'),
        meta: { title: '保障管理' }
      },
      {
        path: 'inspection-item',
        name: 'InspectionItemManage',
        component: () => import('@/views/InspectionItemManage.vue'),
        meta: { title: '检测项目管理' }
      },
      {
        path: 'inspection-template',
        name: 'InspectionTemplateManage',
        component: () => import('@/views/InspectionTemplateManage.vue'),
        meta: { title: '检测项模板管理' }
      },
      {
        path: 'vehicle-brand',
        name: 'VehicleBrandManage',
        component: () => import('@/views/VehicleBrandManage.vue'),
        meta: { title: '车辆品牌管理' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局路由守卫 - 简单登录校验
router.beforeEach((to, from, next) => {
  const whiteList = ['/login']

  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }

  if (whiteList.includes(to.path)) {
    return next()
  }

  // 假登录校验：从缓存读取 auth，解码并校验账号密码
  const authStr = localStorage.getItem('auth') || sessionStorage.getItem('auth')
  if (!authStr) {
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }
  try {
    const auth = JSON.parse(authStr)
    const username = auth && auth.username
    const password = auth && auth.password ? atob(auth.password) : ''
    const valid = username === 'admin' && password === '123456'
    if (valid) {
      return next()
    }
  } catch (e) {
    // 无效的缓存格式，需重新登录
    console.warn('Invalid auth cache, redirecting to login', e)
  }
  return next({ path: '/login', query: { redirect: to.fullPath } })
})

export default router